import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID,
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID,

    ACTION_QUILLDOCUMENTIMAGE_SAVE,

    ACTION_QUILLDOCUMENTIMAGE_CREATE,

    IQuillDocumentImageLoadByIdAction,
    IQuillDocumentImageLoadByQuillDocumentIdAction,
    IQuillDocumentImageLoadFailureAction,
    IQuillDocumentImageLoadSuccessAction,

    IQuillDocumentImageSaveAction,
    IQuillDocumentImageSaveSuccessAction,
    IQuillDocumentImageSaveFailureAction,

    IQuillDocumentImageCreateAction,
    IQuillDocumentImageCreateSuccessAction,
    IQuillDocumentImageCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/quillDocumentImage";
import { quillDocumentImageApi } from "../services/quillDocumentImage";


export const
    getQuillDocumentImageByIdEpic = (action$): Observable<IQuillDocumentImageLoadSuccessAction | IQuillDocumentImageLoadFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID)
            .mergeMap((action: IQuillDocumentImageLoadByIdAction) => {
                return quillDocumentImageApi
                    .getQuillDocumentImageById(action.id)
                    .map(response =>
                        LoadSuccess(response.quillDocumentImage, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getQuillDocumentImageByQuillDocumentIdEpic = (action$): Observable<IQuillDocumentImageLoadSuccessAction | IQuillDocumentImageLoadFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID)
            .mergeMap((action: IQuillDocumentImageLoadByQuillDocumentIdAction) => {
                return quillDocumentImageApi
                    .getQuillDocumentImageByQuillDocumentId(action.quillDocumentId)
                    .map(response =>
                        LoadSuccess(response.quillDocumentImages, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setQuillDocumentImageEpic = (action$): Observable<IQuillDocumentImageSaveSuccessAction | IQuillDocumentImageSaveFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENTIMAGE_SAVE)
            .mergeMap((action: IQuillDocumentImageSaveAction) => {
                return quillDocumentImageApi
                    .setQuillDocumentImage(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.quillDocumentImage, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createQuillDocumentImageEpic = (action$): Observable<IQuillDocumentImageCreateSuccessAction | IQuillDocumentImageCreateFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENTIMAGE_CREATE)
            .mergeMap((action: IQuillDocumentImageCreateAction) => {
                return quillDocumentImageApi
                    .createQuillDocumentImage(action.quillDocumentId)
                    .map(response =>
                        CreateSuccess(
                            response.quillDocumentImage,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }